import { forwardRef, useCallback } from 'react';
import { setRef } from '../../utilities/RefUtilities';

/**
 * @typedef {{
 *      contextRef: React.Ref<CanvasRenderingContext2D | null>
 * } & Partial<React.CanvasHTMLAttributes<HTMLCanvasElement>} CanvasProps
 */

export default forwardRef(Canvas);

/**
 * React wrapper over an HTML canvas element
 *
 * @param {CanvasProps} props
 * @param {React.Ref<HTMLCanvasElement>} [ref]
 */
function Canvas(props, ref) {
    const { contextRef, ...restProps } = props;

    const setEl = useCallback(
        (/** @type {HTMLCanvasElement} */ el) => {
            if (!el) return;

            const context = el.getContext('2d');

            setRef(ref, el);
            setRef(contextRef, context);
        },
        [contextRef, ref]
    );

    return <canvas ref={setEl} {...restProps} />;
}
